export type ThemeColors = {
  background: string;
  surface: string;
  surfaceSubtle: string;
  text: string;
  textSecondary: string;
  textMuted: string;
  border: string;
  borderSubtle: string;
  primary: string;
  primaryBg: string;
  danger: string;
  dangerBg: string;
  dangerBorder: string;
  success: string;
  warning: string;
  tabBar: string;
  tabBarBorder: string;
};

export const lightColors: ThemeColors = {
  background:    "#ffffff",
  surface:       "#ffffff",
  surfaceSubtle: "#F1F5F9",
  text:          "#111827",
  textSecondary: "#6B7280",
  textMuted:     "#9CA3AF",
  border:        "#E2E8F0",
  borderSubtle:  "#F1F5F9",
  primary:       "#56B7FD",
  primaryBg:     "#EFF6FF",
  danger:        "#EF4444",
  dangerBg:      "#FEF2F2",
  dangerBorder:  "#FEE2E2",
  success:       "#22C55E",
  warning:       "#F59E0B",
  tabBar:        "#ffffff",
  tabBarBorder:  "#E2E8F0",
};

export const darkColors: ThemeColors = {
  background:    "#181a1b",
  surface:       "#181a1b",
  surfaceSubtle: "#2A2B2E",
  text:          "#F9FAFB",
  textSecondary: "#9CA3AF",
  textMuted:     "#6B7280",
  border:        "#6B7280",
  borderSubtle:  "#374151",
  primary:       "#56B7FD",
  primaryBg:     "#1E3A5F",
  danger:        "#EF4444",
  dangerBg:      "#450A0A",
  dangerBorder:  "#7F1D1D",
  success:       "#22C55E",
  warning:       "#F59E0B",
  tabBar:        "#181a1b",
  tabBarBorder:  "#4B5563",
};

export default {
  light: {
    text: lightColors.text,
    background: lightColors.surface, 
    tint: lightColors.primary,
    tabIconDefault: "#ccc",
    tabIconSelected: lightColors.primary,
  },
  dark: {
    text: darkColors.text,
    background: darkColors.surface,
    tint: darkColors.primary,
    tabIconDefault: "#555",
    tabIconSelected: darkColors.primary,
  },
  multiSteps: {
    background: "#244263",
  },
};
